<template>
  <div>
    <div class="pageWidtn" style="margin-top: 32px;margin-bottom: 331px;">
      <div>
        <p>
          <i
            class="iconfont icon-shangyige"
            @click="goBack"
            style="color: #313131;cursor: pointer;"
          ></i>
          <span class="modify-head-name">修改记录</span>
        </p>
        <p style="margin-top:33px;">
          <Row type="flex" justify="start" align="middle">
            <Col>
              <z-panelimg
                v-if="itemRecords && itemRecords.length > 0"
                :del="false"
                :src="
                  `${ossPrefix}${itemRecords[0] &&
                    itemRecords[0].product &&
                    itemRecords[0].product.coverFile &&
                    itemRecords[0].product.coverFile.key}`
                "
              ></z-panelimg>
            </Col>
            <Col span="22" style="margin-left:20px;">
              <p style="font-weight: 500;">
                {{
                  itemRecords[0] &&
                    itemRecords[0].product &&
                    itemRecords[0].product.name
                }}
              </p>
              <p style="color: #707070;">
                {{
                  itemRecords[0] &&
                    itemRecords[0].product &&
                    itemRecords[0].product.code
                }}
              </p>
            </Col>
          </Row>
        </p>
      </div>
      <div class="products">
        <modify-item-record
          v-if="itemRecords"
          :lists="itemRecords"
        ></modify-item-record>
      </div>
    </div>
  </div>
</template>

<script>
import { OLD_BASIC_URL } from "@/constants";
import axios from "axios";
import mock from "@/utils/mock";
import layout from "./common/layout";
import priceShow from "./common/price-show";
import logs from "./common/logs";
import modifyItemRecord from "@/components/modify-item-record";
import { download } from "@/utils";
import _ from "lodash";
import { permissionFuc } from "@/utils/permissions.js";

export default {
  data() {
    return {
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL,
      itemRecords: ""
    };
  },
  components: {
    layout,
    modifyItemRecord
  },
  beforeRouteEnter(to, from, next) {
    axios
      .get(
        `/designer_api/stageOrders/${to.params.orderId}/item/${to.params.orderItemId}/modify_record`,
        {
          globalLoading: true
        }
      )
      .then(res => {
        next(vm => {
          vm.itemRecords = res;
        });
      });
  },
  props: {
    lists: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.modify-details {
  text-align: right;

  &-cal {
    margin: 50px;
    .name_price {
      color: #313131;
      font-size: 16px;
    }
    .price {
      color: #eb5757;
      font-size: 18px;
      // margin-right: 20px;
    }
  }
}

.modify-head {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #707070;
  padding: 8px;
  &-name {
    font-size: 18px;
    line-height: 18px;
    color: #313131;
    padding-left: 8px;
  }
  &-qty {
    color: black;
    padding-right: 4px;
  }
}
/deep/.modify-row-badge-wait {
  background: #f7dfde !important;
  color: #eb5757;
}
/deep/.modify-row-badge-confirmed {
  background: rgba(68, 215, 182, 0.28) !important;
  color: #44d7b6;
}
/deep/.modify-row-badge-cancel {
  background: #f1f1f1 !important;
  color: #999999;
}
</style>
